import React, { useEffect, useState, useRef } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import base from "../util/base";
import { useAuth } from "../util/auth";
import ReactPlayer from "react-player";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  media: {
    height: 160,
  },
}));

const YOUTUBE_PLAYLIST_ITEMS_API =
  "https://www.googleapis.com/youtube/v3/playlistItems";

function ContentCardsSection(props) {
  const player = useRef();
  const [videos, setVideos] = useState([]);
  const [vidID, setID] = useState();
  const [inAppVid, setInAppVid] = useState("");
  const auth = useAuth();

  useEffect(() => {
    const getURL = async () => {
      base("Users")
        .select({
          view: "Grid view",
          filterByFormula: `{Email} = '${auth.user.email}'`,
        })
        .firstPage(function (err, records) {
          if (err) {
            console.error(err);
            return;
          }
          records.forEach(function (record) {
            setID(record.get(`playlistID`));
          });
        });
    };
    getURL();
  });

  useEffect(() => {
    async function displayVid() {
      fetch(
        `${YOUTUBE_PLAYLIST_ITEMS_API}?part=snippet&playlistId=${vidID}&maxResults=20&key=${process.env.REACT_APP_YOUTUBE_API_KEY}`
      )
        .then((response) => response.json())
        .then((json) => {
          const newData = json.items.map((item) => {
            return item;
          });
          console.log(newData);
          setVideos(newData);
        });
    }
    if (vidID) {
      displayVid();
    }
  }, [auth.user.email, vidID]);

  useEffect(() => {
    async function showInApp() {
      setInAppVid(
        `https://www.youtube.com/playlist?list=${videos[0].snippet.playlistId}`
      );
    }
    if (videos.length > 0) {
      showInApp();
    }
  }, [videos]);

  const classes = useStyles();

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={4}
          textAlign="center"
        />
        {videos.length !== 0 ? (
          <Grid container={true} justifyContent="center" spacing={4}>
            <Grid item={true} xs={12} align="center">
              <Card>
                <ReactPlayer ref={player} url={inAppVid} controls />
              </Card>
            </Grid>
            {videos.map((item, index) => (
              <Grid item={true} xs={12} md={6} lg={3} key={item.id}>
                <Card>
                  <CardActionArea
                    onClick={() => {
                      setInAppVid(
                        `https://www.youtube.com/watch?v=${item.snippet.resourceId.videoId}`
                      );
                      console.log(inAppVid);
                    }}
                  >
                    <CardMedia
                      image={item.snippet.thumbnails.medium.url}
                      title={item.snippet.title}
                      className={classes.media}
                    />
                    <CardContent>
                      <Typography
                        variant="h5"
                        component="h2"
                        gutterBottom={true}
                      >
                        {item.snippet.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      ></Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Card>
            <CardContent className={classes.cardContent}>
              <Box>
                <Typography variant="h4" paragraph={true}>
                  <strong>Your exercises are not available yet...</strong>
                </Typography>
                <Typography variant="h5" paragraph={true}>
                  Check Back Later
                </Typography>
              </Box>
            </CardContent>
          </Card>
        )}
      </Container>
    </Section>
  );
}

export default ContentCardsSection;
